import BN from 'bn.js';
export function roundDecimalSignificantsUp(value, significantDigits = 21) {
    const [int, dec] = value.toString().split('.');
    if (!dec)
        return value;
    const flippingPoint = significantDigits - (int === '0' || int === undefined ? 0 : int.length) + 1;
    const decimal = Number(`0.${dec}`);
    const shouldRound = 1 - decimal <= (5 + 1e-6) * 10 ** -flippingPoint;
    if (shouldRound) {
        const bn = new BN(int ?? 0);
        const rounded = int?.startsWith('-') ? bn.subn(1) : bn.addn(1);
        return (typeof value === 'string' ? rounded.toString() : rounded.toNumber());
    }
    return value;
}
export function padDecimals(value, length) {
    value = value.toString();
    const [int, dec] = value.split('.');
    if (!dec)
        return `${value}.${'0'.repeat(length)}`;
    return dec.length < length ? `${int}.${dec}${'0'.repeat(length - dec.length)}` : value;
}
const suffixes = ['st', 'nd', 'rd'];
export function asOrdinal(number) {
    const mod10 = number % 10;
    const mod100 = number % 100;
    if ([1, 2, 3].includes(mod10)) {
        const suffix = mod100 > 10 && mod100 < 20 ? 'th' : suffixes[mod10 - 1];
        return `${number}${suffix}`;
    }
    return `${number}th`;
}
